<template>
    <!-- Form 1 Template -->
    <v-container>
        <UserInfo :company="company" ref="userinfo"></UserInfo>
        <Activities ref="activities"></Activities>
        <component v-for="(page, index) in pages" :ref="reference(index)" :section="index + 1" :key="page['id']" :is="page"></component>
        {{ percentage() }}%
        <submit @submitForm="validate()" :isSubmit="isSubmit" :error_msg="error_msg"></submit>
    </v-container>
</template>
<script>
import Lighting from './form1/Lighting';
import UserInfo from './form1/UserInfo';
import Activities from './form1/Activities';
import Surface from './form1/Surface';
import Keyboard from './form1/Keyboard';
import Weight from './form1/Weight'
import Monitor from './form1/Monitor';
import Chair from './form1/Chair';
import Breaks from './form1/Breaks';
import Submit from './form1/Submit';
import Stage from '@/components/Stage';
import db from '@/components/firebase.init';
export default {
    data(){
        return{
            company: {},
            numberOfPage:0,
            total_score: 0,
            total_na: 0,
            pages:['Surface', 'Keyboard','Lighting','Weight', 'Monitor','Chair', 'Breaks'],
            currentPage: "",
            window:{
                width: 0,
                height: 0
            },
            id: '',
            isSubmit: false,
            error_msg: [],
            company_id: this.$route.params.companyId,
            showButton: false,
            showMenu: true,
        }
    },
    methods:{
        percentage(){
            return parseInt((33-this.total_score-this.total_na) / (33 - this.total_na) * 100)
        },
        getTotalScore(){
            for(var x = 0; x <= this.numberOfPage; x++ ){
                let score = this.$refs['page' + x][0].getTotalScore();
                let na = this.$refs['page' + x][0].getTotalNa();
                this.total_score += score
                this.total_na += na
            }
        },
        getCompany(){
            db.collection('company').doc(this.company_id).get()
            .then(doc =>{
                this.company = doc.data();
                Object.assign(this.company, {id: this.company_id});
            })
        },
        found(event){
            return event.type == 'enter';
        },
        handleResize(){
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
            if(this.window.width <= 1224){
                this.showButton = true;
                this.showMenu = false;
            }
        },
        reference(index){
            this.numberOfPage = index;
            return 'page' + index;
        },
        savePercentage(id){
            let percentage = this.percentage()
            console.log(percentage);
            db.collection('forms').doc(id).update(
                {
                    percentage: percentage
                }
            )
        },
        //submit all form using their own submit methods
        submit(){
            this.isSubmit = true;
            this.getTotalScore();
            this.$refs.userinfo.submit()
            .then(data =>{
                let id = data.id;
                this.$refs.activities.submit(id);
                for(var x = 0; x <= this.numberOfPage; x++){
                    this.$refs['page' + x][0].submit(id);
                }
                this.savePercentage(id);
                alert('Form Submitted')
                this.isSubmit = false;
                this.$router.push('/success');
            })
            .catch(e =>{
                alert(e);
                this.isSubmit = false;
            });
            
        },
        //validate forms
        validate(){
            this.error_msg = [];
            let valid = this.$refs.userinfo.validate();
            //if user info have not been filled or invalid
            if(!valid){
                this.error_msg.push('Personal Info')
            }
            //validate the rest of the forms
            for(var x = 0; x <= this.numberOfPage; x++){
                if(this.$refs['page' + x][0].invalid()){
                    this.error_msg.push(x+1);
                }
            }
            //if no errors, proceed to submit
            if(!this.error_msg.length){
                this.submit();
            }
        }
    },
    components:{
        Lighting,
        UserInfo,
        Activities,
        Surface,
        Keyboard,
        Weight,
        Monitor,
        Chair,
        Breaks,
        'submit' : Submit,
        'stage' : Stage
    },
    beforeMount(){
        this.getCompany();
    },
    created(){
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('touchstart',(ev)=>{
            if(ev.id == this.id){
                console.log("test") 
                this.currentPage = e.id;
                console.log(this.currentPage);
            }
        });
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>

